import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '~/@api/client/authStore'
import { _trackHsqIdentity } from '~/@lib_integrations/analytics/hubspot'
import Analytics from '~/@lib_integrations/analytics/analytics'
import { setLoggedUserEmailToACVisitor } from '~/@lib_integrations/analytics/activeCampaign'
import { useAffilToken } from './affiliate/useAffilToken'
import { useAmbassadorCode } from '~/@biz_ambassador/code/useAmbassadorCode'
import {
  useRegister,
  type RegisterRequest,
} from '~/@mid_registration/register-form/useRegister'
import RegistrationComponent from '~/@mid_registration/RegistrationComponent'

function RegisterPage() {
  const { setAuthToken } = useAuthStore()
  const navigate = useNavigate()
  const { tokenAffilRecommender, removeToken: removeAffilToken } =
    useAffilToken()
  const { ambassadorCode, removeAmbassadorCode } = useAmbassadorCode()
  const { error, registerUserMutation, isRegisterRequesting } = useRegister()

  function handleRegisterUser(data: RegisterRequest) {
    registerUserMutation(
      {
        ...data,
        tokenAffilRecommender,
        ambassadorCode,
      },
      {
        onSuccess: (resp) => {
          setAuthToken(resp.auth)
          removeAffilToken()
          removeAmbassadorCode()

          Analytics.track('user-registered')
          setLoggedUserEmailToACVisitor(data.email)
          _trackHsqIdentity(data.email)

          navigate('/get-started')
        },
      }
    )
  }

  return (
    <RegistrationComponent
      isRegistering={isRegisterRequesting}
      handleRegisterUser={handleRegisterUser}
      error={error}
    />
  )
}

export default RegisterPage
